import { ActionType, ErrorCode } from "../constants";
import { vidData } from "../utils/videoUtils";
const testing = false;
const initialState = {
  testing,
  txtPanels: testing
    ? [
        {
          eduId: 43,
          title: "The Importance of Following Up After an Interview:",
          subtitle:
            "An important step in the interview process is making sure you follow up after they’re done. Why?",
          author: "Alejandra",
          description: [
            [
              "li-1",
              "It demonstrates professionalism - take the time to thank your interviews/recruiters for their time. ",
            ],
            [
              "li-2",
              "Showcase your enthusiasm and passion for the position and company",
            ],
            [
              "li-3",
              "Reinforces your qualifications - this is another opportunity to succinctly highlight why you are the best candidate for the role",
            ],
            [
              "li-4",
              "Relationship building - this is an opportunity - regardless of the outcome - to expand your network and build relationships with your recruiters, interviewers, and companies you engage with. This might benefit you in the future!",
            ],
            [
              "div",
              "Keep in mind - Follow Up Emails are not meant to be long; keep it short and to the point. Do not use it as an opportunity to write an essay on yourself. A few sentences or short paragraphs that are well written can be much more effective than a long email.",
            ],
            ["div", "Below is a template you can use:"],
          ],
          lastElement: 30,
          showIdx: 2,
          download_name: "interview_followup",
          tags: [
            "internships",
            "university",
            "interview",
            "professionalDevelopment",
          ],
        },
        {
          eduId: 42,
          title: "Tips for Negotiating a Salary",
          subtitle: "",
          author: "Fetti",
          description: [
            [
              "div",
              "First of all - always attempt to negotiate. It doesn’t  hurt to ask. Somebody saying “No” to you is the worst that could happen, and if it does, at least you tried to advocate for yourself.",
            ],
            [
              "div",
              "So how do you negotiate? You can’t just say “I want more money, I deserve it.” You have to justify your request. Here are some examples:",
            ],
            [
              "li-1",
              "Do your research on the market and the role - what do they pay others at the company in your same role with the same experience? What do other companies pay their employees in a comparable role?",
            ],
            [
              "li-2",
              "Have you interviewed and received an offer elsewhere? Use that offer as leverage. Generally speaking, the more information you give the recruiter, the more they might be able to do for you.",
            ],
            [
              "div",
              "Have confidence in yourself. Justify your salary with your qualifications and experience. Talking about compensation can be personal and sometimes emotional for the candidate. So make sure you maintain professionalism and be polite, regardless of the outcome. Negotiation doesn’t always work, or you might not get exactly what you want, or it may not actually be possible - some employers don’t do it, some give standardized offers, or the highest offer possible at the initial offer. Keep in mind it varies employer to employer. But the important thing is to always try - you never know what the response might be. ​​Negotiating your salary as an intern/new grad is a great opportunity to learn how to advocate for yourself, as this is something you will encounter many times throughout your career!",
            ],
            ["x-div", ""],
            [
              "div",
              "Script you can use (modify based on the skillsets you want to highlight): ",
            ],
            [
              "html-div",
              "“I am so honored to be joining the team. I have enjoyed my interactions with everyone during the interview process. Is there any chance of flexibility in compensation? Based on a few additional conversations I am having, market research, as well as the experience I am bringing as a new grad with 3 years of experience building and launching iOS apps from the ground up since my first internship my sophomore year of college, I would love it if we could potentially meet at $<b>[Desired Amount]</b>.”",
            ],
          ],
          lastElement: 30,
          showIdx: 2,
          download_name: "",
          tags: [
            "internships",
            "university",
            "interview",
            "professionalDevelopment",
          ],
        },
        {
          eduId: 40,
          title: "List of questions you can ask your interviewer:",
          subtitle: "",
          author: "Alejandra",
          description: [
            [
              "li-1",
              "What skills or qualities do you think are most important for success in this internship?",
            ],
            [
              "li-2",
              "How does this internship provide opportunities for professional growth and development?",
            ],
            [
              "li-3",
              "Can you describe the company culture and what it's like to work here?",
            ],
            [
              "html-li-4",
              "How does <b>[Company Name]</b> support and mentor its interns?",
            ],
            [
              "li-5",
              "What do you think sets this internship apart from others in the industry?",
            ],
            [
              "li-6",
              "What are some of the challenges or opportunities that the company is currently facing?",
            ],
            [
              "html-li-7",
              "Is there any advice you would be able to offer me as someone starting out in <b>[Industry Name]</b>?",
            ],
          ],
          lastElement: 30,
          showIdx: 2,
          download_name: "",
          tags: ["internships", "university", "interview"],
        },
        {
          eduId: 39,
          title: "How can I stand out in an interview?",
          subtitle:
            "There are still several things you can do as a college student to stand out in an interview, even without much professional experience.",
          author: "Alejandra",
          description: [
            [
              "li-1",
              "Take time to research the company: Prepare yourself for the interview by researching the company and the position you are applying for. You can prepare thoughtful questions for the interview by understanding the company's values, goals, and culture.",
            ],
            [
              "li-2",
              "Practice common interview questions: You can prepare for the interview by practicing common interview questions with a friend or family member. In addition, you will be able to articulate your skills and experiences more clearly.",
            ],
            [
              "li-3",
              "Prepare to talk about your achievements: Discuss your achievements and how they relate to the position you are applying for. Whenever possible, use data or metrics to demonstrate the impact of your accomplishments. When answering questions, use the STAR method to ensure your responses are clear and structured, and so that the interviewer can better understand your problem-solving abilities.",
            ],
            [
              "li-4",
              "Talk about relevant skills and experiences: Highlight your relevant skills and experiences, whether through coursework, extracurricular activities, or part-time employment. ",
            ],
            [
              "li-5",
              "Having a positive attitude and being enthusiastic: A positive attitude, enthusiasm, and personability are qualities employers look for in candidates. Show your passion for the position and industry by smiling and making eye contact.",
            ],
            [
              "li-6",
              "Ask thoughtful questions: Prepare a list of questions to ask the interviewer about the company or the position. You can use this to demonstrate your interest and engagement in the interview (see examples below).",
            ],
            [
              "li-7",
              "Follow up after the interview: Thank the interviewer for their time after the interview and reiterate your interest in the position in a thank-you note or email.",
            ],
          ],
          lastElement: 30,
          showIdx: 2,
          download_name: "",
          tags: ["internships", "university", "interview"],
        },
        {
          eduId: 38,
          title: "Tackling Imposter Syndrome While Applying for Opportunities",
          subtitle: "",
          author: "Austin",
          description: [
            [
              "html-div",
              "<b>It’s natural to feel imposter syndrome</b> when applying for internships or entering the workforce. Here are some tips to overcome it while building confidence when applying for internships or full-time positions:",
            ],
            [
              "li-1",
              "Don’t forget - you belong here! Remember how much you have accomplished personally and professionally. Spend some time thinking about all you’ve achieved and how far you’ve come - it’s easy to forget this about ourselves.",
            ],
            [
              "li-2",
              "Build a support system - Talk to family and friends, or a mentor if you have one, about how you’re feeling. Seek advice from them. Remember - you’re not alone - everyone goes through what you are experiencing now at one point or another.",
            ],
            [
              "li-3",
              "Look at this process as a learning experience - Look at “No’s” as “not right now, but maybe later.” Career moves are all about timing, it’s not personal. And if possible, always ask for feedback from your interviewers or recruiters if they are willing to give it. Treat every interview as a learning experience.",
            ],
            [
              "li-4",
              "Be well prepared - this will help you feel more confident. Spend time researching the company, their leadership team, mission, and news articles. Not only will this help you learn about a future employer, it will also give you talking points in the interview.",
            ],
            [
              "li-5",
              "Finally - be kind to yourself. Looking for a job is a job in itself. Take breaks, and after you’ve completed a good amount of work for the day or maybe finished a day's worth of interviews, go do something completely different to get your mind off of it.",
            ],
          ],
          lastElement: 30,
          showIdx: 2,
          download_name: "",
          tags: [
            "professionalDevelopment",
            "leadership",
            "internships",
            "university",
          ],
        },
        {
          eduId: 35,
          title:
            "How to Overcome Imposter Syndrome When Applying for Opportunities",
          subtitle: "",
          author: "Alejandra",
          description: [
            [
              "div",
              "Many college students experience imposter syndrome when applying for internships or entering the workforce for the first time. Here are some tips for overcoming imposter syndrome and building confidence while applying for internships or full-time positions:",
            ],
            [
              "li-1",
              "Reflect on your academic and personal achievements. Make a list of everything you've done so far and give yourself a pat on the back! Sometimes people forget everything they’ve accomplished until they take time to reflect. ",
            ],
            [
              "li-2",
              "Getting support can help you feel less alone and more confident! Talking to a trusted friend, family member, or mentor can help. Just remember, you are not alone and the feeling of imposter syndrome is something many experience.",
            ],
            [
              "li-3",
              "Take the application process with a growth mindset and a willingness to learn. You only need one “Yes” and a “No” now, is not a no forever nor a reflection of your capabilities. If possible, ask for feedback at the end of an interview if you are not chosen to move forward so that you can continue to grow and improve your interview skills.",
            ],
            [
              "li-4",
              "The more prepared you are, the more confident you will feel during your interview. Research the company and opportunity you are applying to thoroughly, and prepare for the interview.",
            ],
            [
              "li-5",
              "Lastly, remember to always take care of yourself! Engage in activities that help you when you might be stressed in the job search such as going for a run, having lunch with friends, or going to the movies.",
            ],
          ],
          lastElement: 30,
          showIdx: 2,
          download_name: "",
          tags: [
            "professionalDevelopment",
            "leadership",
            "internships",
            "university",
          ],
        },
        {
          eduId: 34,
          title:
            "How to have a 1:1 with my manager (as an intern or new grad hire):",
          subtitle: "",
          author: "Fetti",
          description: [
            [
              "div",
              "Regular 1:1s with your manager as an intern can be a valuable way to develop your skills, build relationships, and achieve your career goals. By maintaining open communication and a proactive attitude, you can demonstrate your value to your team and position yourself for future success.",
            ],
            [
              "div",
              "During the first week of your internship/new grad position, you should:",
            ],
            [
              "li-1",
              "Ask your manager if they are willing to meet with you on a regular basis. Explain to your manager that you want to establish a strong working relationship, get feedback on your work, and ensure you meet their expectations. ",
            ],
            [
              "li-2",
              "Follow-up by scheduling the 1:1 meetings: Meetings are usually once a week but that is also something you can confirm with your manager (how often they would like to meet). When scheduling recurring 1:1s, make sure it is on a day and time that is convenient for you and your manager.",
            ],
            [
              "li-3",
              "It is essential that you prepare an agenda for each meeting, including updates on your work, questions you have, and feedback you would like to share. Having an ongoing document listing out what you will be discussing at each meeting is a great way to track all of your work. This will help when you need to look back on what you’ve accomplished when it is time for evaluations in your internship.",
            ],
            [
              "li-4",
              "Optional but recommended: Make sure your manager is on the same page after every meeting, which might include sending an action item list or a meeting summary after your 1:1s.",
            ],
            ["x-div", ""],
            ["html-div", "<b><u>Example:</u></b>"],
            ["html-div", '<font face="Arial">Hi [Manager Name]!</font>'],
            [
              "html-div",
              '<font face="Arial">Just wanted to follow up after our call. As we discussed in our 1:1:</font>',
            ],
            [
              "html-li-1",
              '<font face="Arial">I will finish the [Project Name] by [Deadline].</font>',
            ],
            [
              "html-li-2",
              '<font face="Arial">Will send over a draft of the [Project Name] by next week.</font>',
            ],
            [
              "html-div",
              '<font face="Arial">As always, I will keep you updated if anything changes on my end. Let me know if you have any questions!</font>',
            ],
            ["x-div", ""],
            [
              "div",
              "Use the template below to help structure your agenda for your 1:1s with your manager (This template can be modified based on your specific needs):",
            ],
            [
              "div",
              "Remember, in order to establish a strong relationship with your manager, be honest and open about your goals and challenges during one-on-one meetings. Communication is key, and you will be able to develop and grow as an intern/new grad as a result of this.",
            ],
          ],
          lastElement: 30,
          showIdx: 2,
          download_name: "oneonone_template",
          tags: [
            "professionalDevelopment",
            "skillDevelopment",
            "leadership",
            "internships",
            "university",
            "whileYoureAtWork",
          ],
        },
        {
          eduId: 31,
          title: "How to reach out to individuals for a “coffee chat”?",
          subtitle: "",
          author: "Fetti",
          description: [
            [
              "div",
              'You should respect the time and schedule of individuals when approaching them for a "coffee chat" or informational interview. To get you started, here are some tips:',
            ],
            [
              "li-1",
              "Prior to contacting someone, research the individual. You will show that you have actually done your research and are sincerely interested in what they’re doing.",
            ],
            [
              "html-li-2",
              "Make sure your email is concise: Introduce yourself briefly, explain why you want to reach out, and suggest a time that works for you.",
            ],
            [
              "html-li-3",
              "Remember to be flexible: You should be considerate of the busy schedule of the person you’re contacting. It's important to be flexible and offer alternative times and dates if needed.",
            ],
            [
              "html-li-4",
              "Remember to be respectful of their time: Keep the meeting short and to the point. After the meeting, be sure to thank them for their time and follow up with a thank-you note (<b>find a thank-you template below</b>).",
            ],
            [
              "div",
              "Taking these steps can help you establish valuable connections and build a strong professional network.",
            ],
          ],
          lastElement: 30,
          showIdx: 2,
          download_name: "thankyou_template",
          tags: ["professionalDevelopment", "networking", "leadership"],
        },
        {
          eduId: 30,
          title: "How to Build a Network",
          subtitle: "",
          author: "Fetti",
          description: [
            [
              "div",
              "Developing your professional network as a college student is critical for establishing professional connections and career prospects. The following are some steps you can take to build your network:",
            ],
            [
              "li-1",
              "Participate in networking events: Take part in job fairs, career fairs, and other networking events hosted by your university or community. In addition to meeting professionals in your field of interest, these events are also a great chance to network.",
            ],
            [
              "li-2",
              "Connect to companies you are interested in working at through their careers website and social channels. Most employers now build career and recruiting brands around themselves, and engaging with them allows you to learn more about them, and it allows them to communicate to their prospective candidates about upcoming events, opening roles., etc.",
            ],
            [
              "html-li-3",
              "Become a member of clubs and organizations: Getting involved in clubs and organizations related to your major or field of interest can be an excellent way to meet like-minded individuals and professionals. These groups often bring in recruiters and professionals from industry as guest speakers or to run events.",
            ],
            [
              "html-li-4",
              "Getting in touch with alumni: Contact alumni who work in your field of interest from your university. Alumni can be found through your university's alumni network or LinkedIn.",
            ],
            [
              "html-li-5",
              "Use LinkedIn: LinkedIn is a great tool for building your professional network. Get connected to professionals in your field by creating a LinkedIn profile. If you are interested in a specific field, you can also join LinkedIn groups.",
            ],
            [
              "html-li-6",
              "Informational interviews: Request informational interviews from professionals in your field. This is a great way to learn more about their career path, as well as to gain valuable insight and advice (<b>below is a template you can use</b>).",
            ],
          ],
          lastElement: 30,
          showIdx: 2,
          download_name: "outreach_template",
          tags: ["professionalDevelopment", "networking", "leadership"],
        },
        {
          eduId: 29,
          title: '"Do you have any questions for us?"',
          subtitle: '"How To Answer?" Interview Prep',
          author: "Fetti",
          description: [
            ["div", "Example questions you can ask:"],
            [
              "li",
              "What skills or qualities do you think are most important for success in this internship?",
            ],
            [
              "html-li",
              "How does this internship provide opportunities for professional growth and development?",
            ],
            [
              "html-li",
              "Can you describe the company culture and what it's like to work here?",
            ],
            [
              "html-li",
              "How does <b>[Company Name]</b> support and mentor its interns?",
            ],
            [
              "html-li",
              "What do you think sets this internship apart from others in the industry?",
            ],
            [
              "html-li",
              "What are some of the challenges or opportunities that the company is currently facing?",
            ],
            [
              "html-li",
              "Is there any advice you would be able to offer me as someone starting out in <b>[Industry Name]</b>?",
            ],
          ],
          lastElement: 30,
          showIdx: 2,
          download_name: "",
          tags: [
            "university",
            "interview",
            "professionalDevelopment",
            "internships",
          ],
        },
      ]
    : null,
  vidPanels: vidData, // may be overwritten later
  txtPanelsNotFound: {},
  counts: {},
};
export default (state = initialState, action) => {
  try {
    switch (action.type) {
      case ActionType.addEdu:
        const { panels, tag, totalCount } = action.payload;
        if (state.txtPanels === null) {
          return {
            ...state,
            txtPanels: panels,
            counts: { ...state.counts, [tag]: totalCount },
          };
        }
        // only add if eduId is not already in state
        return {
          ...state,
          txtPanels: [
            ...state.txtPanels,
            ...panels.filter(
              (newPanel) =>
                !state.txtPanels.some(
                  (oldPanel) => oldPanel.eduId === newPanel.eduId
                )
            ),
          ],
          counts: { ...state.counts, [tag]: totalCount },
        };
      case ActionType.eduIdNotFound:
        const { eduId } = action.payload;
        return {
          ...state,
          txtPanelsNotFound: { ...state.txtPanelsNotFound, [eduId]: true },
        };

      default:
        return state;
    }
  } catch (e) {
    console.log("eduReducer error:", e);
  }
};
